var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 200,
    viewBox: "0 0 218 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_6790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.57666 49.4666V144.112C0.57666 146.054 1.61482 147.861 3.30664 148.823L82.5338 194.579C84.2256 195.559 86.3019 195.559 87.9745 194.579L167.202 148.823C168.893 147.842 169.932 146.054 169.932 144.112V49.4666L85.2446 98.3563L0.57666 49.4666Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.576904 49.4667L85.264 0.576904L169.951 49.4667L85.264 98.3756L0.576904 49.4667Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2787 68.3648L117.947 19.4751L137.018 30.4911L52.3309 79.4001L52.2925 116.005L33.2595 105.027L33.2787 68.3648Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2639 98.3755V194.848",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0366 158.935V175.103L43.9104 157.974V141.805L73.0366 158.935Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.72 200C195.999 200 217.303 178.697 217.303 152.418C217.303 126.139 195.999 104.835 169.72 104.835C143.441 104.835 122.138 126.139 122.138 152.418C122.138 178.697 143.441 200 169.72 200Z",
    fill: "#5CD377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.72 170.124V134.711",
    stroke: "white",
    strokeWidth: 1.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.014 152.418L169.72 134.711L187.446 152.418",
    stroke: "white",
    strokeWidth: 1.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_6790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217.303,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelease);
export default __webpack_public_path__ + "static/media/release.494c43b7a9a53239e0e8761b295e3439.svg";
export { ForwardRef as ReactComponent };